import { render, staticRenderFns } from "./parentParticular.vue?vue&type=template&id=d0137cd8&scoped=true"
import script from "./parentParticular.vue?vue&type=script&lang=js"
export * from "./parentParticular.vue?vue&type=script&lang=js"
import style0 from "./parentParticular.vue?vue&type=style&index=0&id=d0137cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0137cd8",
  null
  
)

export default component.exports